import { ICustomMainColor } from './themeAugment';

/**
 * https://chir.ag/projects/name-that-color/#F49B33
 */
export const seaBuckthornColor = '#F49B33';

/**
 * https://chir.ag/projects/name-that-color/#F6F7F6
 */
export const grayNurseColor = '#F6F7F6';

export const brandPalette = {
  dark: '#131315',
  main: '#1e2738',
  light: 'rgba(255, 255, 255, 0.10)',
};

export const greenPalette: ICustomMainColor = {
  100: '#F5F5F5',
  200: '#F8FDFC',
  300: '#F1F7F7',
  350: '#D5EBEC',
  400: '#CEE3E4',

  500: '#1e2738',

  550: 'rgba(237, 84, 9, 1)',
  600: '#6A8787',
  700: '#2E5A5A',

  800: '#1e2738',
  900: '#131315',

  1000: '#OF1D1E',
};

export const greyPalette = {
  50: 'rgba(255, 255, 255, 0.10)',
  100: '#EFEFF1',
  200: '#E6E6E9',
  300: '#DEDEE2',
  400: '#D6D6DA',
  500: '#C9CAD0',
  600: '#B4B5BD',
  700: '#818292',
  800: '#383635',
  900: '#506077',
  light: '#E2E9E9',
  dark: '#20212F',
  A100: '#1F2226',
};

export const successPalette = {
  50: '#ECFDF5',
  100: '#D1FAE5',
  200: '#A7F3D0',
  300: '#6EE7B7',
  400: '#34D399',
  500: 'rgba(237, 84, 9, 1)',
  600: '#059669',
  700: '#047857',
  800: '#065F46',
  900: '#064E3b',
  dark: '#022C22',
};

export const warningPalette = {
  50: '#FEFCE8',
  100: '#FEF9C3',
  200: '#FEFO8A',
  300: '#FDE047',
  350: '#FFF3E7',
  400: '#FACC15',
  500: '#FAB308',
  600: '#CA8A04',
  700: '#A16207',
  800: '#854DOE',
  900: '#713F12',
  dark: '#422006',
  main: '#EAB144',
  light: '#FFF7E4',
};

export const errorPalette = {
  50: '#FEF2F2',
  100: '#FEE2E2',
  200: '#FECACA',
  300: '#FCA5A5',
  400: '#C5A1A1',
  500: '#F87171',
  600: '#DC2626',
  800: '#991B1B',
  900: '#7F1D1D',
  dark: '#450A0A',
};
